import React from "react";
import { useNavigate } from "react-router-dom";
// @mui

import { Box, Button, Container, Typography } from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import LoginIcon from "@mui/icons-material/Login";

import useResponsive from "../hooks/useResponsive";
import { PATH_AUTH } from "../routes/path";

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

const NavStyle = styled("div")(({ theme }) => ({
  height: "100vh",
  flexShrink: 0,
  [theme.breakpoints.up("lg")]: {
    paddingTop: 34,
  },
}));
const UnauthenticatedNavigation = () => {
  const isMedium = useResponsive("down", "md", "xl");

  return (
    <NavStyle
      sx={{
        position: "fixed",
        width: "100%",
        height: 80,
        borderBottom: "1px solid #E7EBEF",
        pt: "0 !important",
        background: "#FAFAFA",
      }}
    >
      <Container
        sx={{
          display: "flex",
          justifyContent: "space-between",
          height: 80,
          paddingLeft: "0",
        }}
      >
        <Box
          sx={{
            borderRight: !isMedium ? "1px solid #E7EBEF" : "",
            // borderLeft: !isMedium ? "1px solid #E7EBEF" : "",
            height: 80,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            px: 4,
          }}
        >
          <img
            src="/assets/icons/logo-green.svg"
            width="100"
            height="36"
            alt=""
            style={{ cursor: "pointer" }}
          />
        </Box>

        <Box>
          <SignUpButton />
        </Box>
      </Container>
    </NavStyle>
  );
};

export default UnauthenticatedNavigation;

const SignUpButton = () => {
  const navigate = useNavigate();
  const isSmall = useResponsive("down", "sm", "xl");
  const isMedium = useResponsive("down", "md", "xl");

  return (
    <Box
      sx={{
        height: 80,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        // borderRight: !isMedium ? "1px solid #E7EBEF" : "",
        borderLeft: !isMedium ? "1px solid #E7EBEF" : "",
        px: 4,
        ml: 4,
      }}
    >
      <Button
        variant="contained"
        endIcon={<LoginIcon />}
        onClick={() => navigate(PATH_AUTH.signUp)}
        sx={{
          borderRadius: "30px",
          boxShadow: "none",
          fontWeight: 400,
          fontSize: "12px",
          width: isSmall ? 40 : 150,
        }}
      >
        {isSmall ? "" : "Sign Up"}
      </Button>
    </Box>
  );
};
